export default "__VITE_ASSET__D0QHSsOu__"